export const PRIORITY = {
  low:    { label: "Baja",    cls: "prio-low" },
  medium: { label: "Media",   cls: "prio-medium" },
  high:   { label: "Alta",    cls: "prio-high" },
  urgent: { label: "Urgente", cls: "prio-urgent" },
};

export const STATUS = {
  pending:     { label: "Pendiente",  cls: "st-pending" },
  in_progress: { label: "En curso",   cls: "st-progress" },
  review:      { label: "En revisión", cls: "st-review" },
  done:        { label: "Completada", cls: "st-done" },
};

export const PRIORITY_ORDER = ["low", "medium", "high", "urgent"];
export const STATUS_ORDER = ["pending", "in_progress", "review", "done"];

export const STATUS_COLOR = {
  pending: "#a2a8c0",
  in_progress: "#f5a524",
  review: "#a47b35",
  done: "#2fbf71",
};

export function initials(name) {
  return (name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
}

// Seguimiento del cronograma (círculo + nombre):
//  gris = sin iniciar, amarillo = a tiempo, rojo = retrasado, verde = ejecutado.
export function scheduleStatus(t) {
  if (t.status === "done") return { key: "done", label: "Ejecutado", color: "#2fbf71" };
  const started = (t.status === "in_progress") || (t.progress ?? 0) > 0;
  if (!started) return { key: "none", label: "Sin iniciar", color: "#a2a8c0" };
  const v = t.variance ?? 0;
  if (v <= -15) return { key: "late", label: "Retrasado", color: "#ef5b6e" };
  return { key: "ontime", label: "A tiempo", color: "#f5a524" };
}
